import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BiRupee } from "react-icons/bi";
import { HiBadgeCheck } from "react-icons/hi";
import { BsBookmarkStarFill, BsStarFill } from "react-icons/bs";
import axios from "axios";
import Rating from "../Rating";
import { ToastContainer } from "react-toastify";
import { SERVER_PATH } from "../../config/env";
import { userInfo } from "../../utils/appInfo";
import { successToaster } from "../../utils/index";
import { getLocalStorage } from "./../../utils/helper";
import { FiCopy, FiShare2 } from "react-icons/fi";
import SocialLinks from "../SocialLinks";
import CustomerReviews from "../Reviews/CustomerReviews";

export default function Product(props) {
  const isLogin = getLocalStorage("uid") ? true : false;
  let nav = useNavigate();
  const [count, setCount] = useState(1);
  const [ratings, setRatings] = useState(0);
  const [allRating, setAllRating] = useState();
  const [data, setData] = useState([]);
  const param = useParams();
  const [userData, setUserData] = useState(false);
  // const [userRating, setUserRating] = useState([]);

  const handleIncrement = () => {
    setCount((prevCount) => prevCount + 1);
  };

  const handleDecrement = () => {
    if (count != 1) setCount((prevCount) => prevCount - 1);
  };

  const toggleState = (clickState) => {
    setRatings(clickState);
  };

  const fetchData = () => {
    axios
      .post(`${SERVER_PATH}get/product.php`, {
        product_id: param.productId,
      })
      .then((res) => {
        let info = res.data.length ? res.data[0] : {};
        setData(info);
        setCount(1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const postData = async (e) => {
    if (isLogin === false) {
      nav("/profile/:productId");
    } else {
      e.preventDefault();
      let info = {
        product_id: param.productId,
        user_id: userData.email,
        quantity: count,
      };

      axios
        .post(`${SERVER_PATH}post/cart.php`, { ...info })
        .then(() => {
          successToaster({ msg: "Added to cart" });
          setCount(1);
        })
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const buyPostData = async (e) => {
    if (isLogin === false) {
      nav("/profile/:productId");
    } else {
      e.preventDefault();
      let info = {
        product_id: param.productId,
        user_id: userData.email,
        quantity: count,
      };

      axios
        .post(`${SERVER_PATH}post/cart.php`, { ...info })
        .then((res) => {
          nav("/cart/:productId");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const swapFocusImg = (key) => {
    let info = { ...data };
    info[key] = info.img1;
    info.img1 = data[key];
    setData(info);
  };

  const overallRating = async () => {
    await axios
      .post(`${SERVER_PATH}get/ratings.php`, {
        product_id: param.productId,
      })
      .then((res) => {
        setAllRating(res.data);
      });
  };

  // const getUserRating = async () => {
  //   await axios
  //     .post(`${SERVER_PATH}get/ratings.php`, {
  //       user_id: userData.email,
  //       product_id: param.productId,
  //     })
  //     .then((res) => {
  //       setUserRating(res.data.rating);
  //     });
  // };

  const submitRating = async (rate) => {
    axios
      .post(`${SERVER_PATH}post/ratings.php`, {
        user_id: userData.email,
        product_id: param.productId,
        rating: rate,
      })
      .then((res) => {
        successToaster({ msg: "Rating added successfully" });
        overallRating();
      });
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    successToaster({ msg: "Copied Successfully" });
  };

  const handleShareProduct = () => {
    if (navigator.share) {
      navigator.share({
        title: data.product_name || "VEBBOX",
        text: `Check out ${data.product_name} on VEBBOX!`,
        url: window.location.href,
      }).catch(() => {});
    } else {
      handleCopyLink();
    }
  };

  useEffect(() => {
    if (!data || !data.product_name) return;

    const schemaData = {
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": data.product_name,
      "image": [data.img1],
      "description": data.description,
      "offers": {
        "@type": "Offer",
        "priceCurrency": "INR",
        "price": data.offer_price,
        "availability": data.status == 1 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
      }
    };

    let script = document.getElementById("jsonld-product-schema");
    if (!script) {
      script = document.createElement("script");
      script.id = "jsonld-product-schema";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schemaData);

    return () => {
      const s = document.getElementById("jsonld-product-schema");
      if (s) s.remove();
    };
  }, [data]);

  useEffect(() => {
    setTimeout(() => {
      setUserData(userInfo());
      fetchData();
      overallRating();
      window.scrollTo(0, 0);
    }, 200);
  }, [param.productId]);

  return (
    <>
      <section className="productPage" key={data.product_id}>
        <div className="container pb-5">
          <div className="row">
            <div className="col-lg-5 mt-5">
              <div className="card mb-3">
                <img
                  className="card-img img-fluid productDetailImg"
                  src={data.img1}
                  alt="vebbox products"
                  id="product-detail"
                />
              </div>
              <div className="row">
                <div className="col-1 align-self-center"></div>
                <div
                  id="multi-item-example"
                  className="col-10 carousel slide carousel-multi-item"
                  data-bs-ride="carousel"
                >
                  <div
                    className="carousel-inner product-links-wap"
                    role="listbox"
                  >
                    <div className="carousel-item active">
                      <div className="row">
                        <div
                          className="col-4"
                          onClick={() => {
                            swapFocusImg("img2");
                          }}
                        >
                          <img
                            className="card-img img-fluid productDetailSubImg"
                            src={data.img2}
                            alt="vebbox products"
                          />
                        </div>
                        <div
                          className="col-4"
                          onClick={() => {
                            swapFocusImg("img3");
                          }}
                        >
                          <img
                            className="card-img img-fluid productDetailSubImg"
                            src={data.img3}
                            alt="vebbox products"
                          />
                        </div>
                        <div
                          className="col-4"
                          onClick={() => {
                            swapFocusImg("img4");
                          }}
                        >
                          <img
                            className="card-img img-fluid productDetailSubImg"
                            src={data.img4}
                            alt="vebbox products"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-1 align-self-center"></div>
              </div>
            </div>
            <div className="col-lg-7 mt-5">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                    <h1 className="h5 text-uppercase productDetailTitle mb-0">
                      {data.product_name}{" "}
                      {data.category !== "wellness" && (
                        <small style={{ fontSize: "15px" }}>
                          ({data.weight} Gms.)
                        </small>
                      )}
                    </h1>
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary rounded-pill d-inline-flex align-items-center gap-1"
                        onClick={handleCopyLink}
                        title="Copy Product Link"
                      >
                        <FiCopy /> <small className="d-none d-sm-inline">Copy Link</small>
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-success rounded-pill d-inline-flex align-items-center gap-1"
                        onClick={handleShareProduct}
                        title="Share Product"
                      >
                        <FiShare2 /> <small className="d-none d-sm-inline">Share</small>
                      </button>
                    </div>
                  </div>
                  <p>
                    <span
                      className="list-inline-item text-dark fw-700"
                      style={{ fontSize: "1.4em" }}
                    >
                      <BiRupee style={{ marginTop: "-3px" }} />
                      {data.offer_price}
                    </span>
                    <span
                      className="list-inline-item text-secondary"
                      style={{
                        fontSize: "1em",
                        textDecoration: "line-through",
                      }}
                    >
                      <BiRupee style={{ marginTop: "-3px" }} />
                      {data.price}
                    </span>
                    <span
                      className="list-inline-item"
                      style={{ fontSize: "1em", color: "green" }}
                    >
                      {data.offer}%{" "}
                      <small style={{ fontSize: ".7em" }}>Discount</small>
                    </span>
                  </p>
                  <form>
                    <input
                      type="hidden"
                      name="product-title"
                      value="Activewear"
                    />
                    {data.category !== "wellness" && (
                      <div className="col-auto">
                        <ul className="list-inline pb-3">
                          <li className="list-inline-item text-right">
                            Quantity
                            <input
                              type="hidden"
                              name="product-quanity"
                              id="product-quanity"
                              value="1"
                            />
                          </li>
                          <li className="list-inline-item">
                            <span
                              className="btn btn-sm btn-success"
                              id="btn-minus"
                              onClick={handleDecrement}
                            >
                              -
                            </span>
                          </li>
                          <li className="list-inline-item">
                            <span
                              className="badge bg-light text-dark"
                              id="var-value"
                            >
                              {count}
                            </span>
                          </li>
                          <li className="list-inline-item">
                            <span
                              className="btn btn-sm btn-success"
                              id="btn-plus"
                              onClick={handleIncrement}
                            >
                              +
                            </span>
                          </li>
                        </ul>
                      </div>
                    )}
                    <div className="row pb-3">
                      <div className="col d-grid">
                        {data.status == 0 ? (
                          <button
                            disabled
                            onClick={buyPostData}
                            type="submit"
                            className="btn btn-success btn-sm py-2 text-uppercase"
                            name="submit"
                            value="buy"
                            style={{
                              borderRadius: "0",
                              letterSpacing: ".2px",
                              fontWeight: "500",
                            }}
                          >
                            Buy Now
                          </button>
                        ) : (
                          <button
                            onClick={buyPostData}
                            type="submit"
                            className="btn btn-success btn-sm py-2 text-uppercase"
                            name="submit"
                            value="buy"
                            style={{
                              borderRadius: "0",
                              letterSpacing: ".2px",
                              fontWeight: "500",
                            }}
                          >
                            Buy Now
                          </button>
                        )}
                      </div>
                      <div className="col d-grid">
                        {data.status == 0 ? (
                          <button
                            disabled
                            onClick={postData}
                            type="submit"
                            className="btn btn-warning btn-sm py-2 text-uppercase"
                            name="submit"
                            value="addtocard"
                            style={{
                              borderRadius: "0",
                              letterSpacing: ".2px",
                              fontWeight: "500",
                            }}
                          >
                            Add To Cart
                          </button>
                        ) : (
                          <button
                            onClick={postData}
                            type="submit"
                            className="btn btn-warning btn-sm py-2 text-uppercase"
                            name="submit"
                            value="addtocard"
                            style={{
                              borderRadius: "0",
                              letterSpacing: ".2px",
                              fontWeight: "500",
                            }}
                          >
                            Add To Cart
                          </button>
                        )}
                      </div>
                    </div>
                  </form>

                  <h6
                    className="text-uppercase mt-3"
                    style={{ color: "#757575" }}
                  >
                    Description:
                  </h6>
                  {data.category == "wellness" && (
                    <>
                      <h4>{data.title1}</h4>

                      <p
                        style={{
                          fontSize: "15px",
                          textAlign: "justify",
                          lineHeight: "1.7em",
                          fontWeight: "350",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {data.description
                          ?.split(".")
                          .filter((item) => item.trim() !== "")
                          .map((item, i) => (
                            <div key={i}>• {item.trim()}.</div>
                          ))}
                      </p>
                      <h4>Benefits you will gain</h4>
                      <p
                        style={{
                          fontSize: "15px",
                          textAlign: "justify",
                          lineHeight: "1.7em",
                          fontWeight: "350",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {data.benefits
                          ?.split(".")
                          .filter((item) => item.trim() !== "")
                          .map((item, i) => (
                            <div key={i}>• {item.trim()}.</div>
                          ))}
                      </p>
                      <div
                        style={{
                          fontSize: "15px",
                          textAlign: "justify",
                          lineHeight: "1.7em",
                          fontWeight: "350",
                        }}
                      >
                        {data.instructions
                          ?.split(".")
                          .filter((item) => item.trim() !== "")
                          .map((item, index) => (
                            <div key={index} style={{ marginBottom: "5px" }}>
                              ➤ {item.trim()}.
                            </div>
                          ))}
                      </div>
                    </>
                  )}
                  {data.category !== "wellness" && (
                    <>
                      <p
                        style={{
                          fontSize: "15px",
                          textAlign: "justify",
                          lineHeight: "1.7em",
                          fontWeight: "350",
                        }}
                      >
                        {data.description}
                      </p>
                      <h6
                        className="text-uppercase mt-3"
                        style={{ color: "#000", fontSize: "15px" }}
                      >
                        <HiBadgeCheck
                          style={{
                            marginTop: "-4px",
                            color: "green",
                            fontSize: "20px",
                          }}
                          className="me-1"
                        />
                        Ingredients:
                      </h6>
                      <ul className="text-capitalize pb-2 ingrediants">
                        <li>{data.ingredients}</li>
                      </ul>
                      <h6
                        className="text-uppercase mt-3"
                        style={{ color: "#000", fontSize: "15px" }}
                      >
                        <HiBadgeCheck
                          style={{
                            marginTop: "-4px",
                            color: "green",
                            fontSize: "20px",
                          }}
                          className="me-1"
                        />
                        Methods of Application:
                      </h6>
                      <p
                        style={{
                          fontSize: "15px",
                          textAlign: "justify",
                          lineHeight: "1.7em",
                          fontWeight: "350",
                        }}
                      >
                        {data.instructions}
                      </p>
                    </>
                  )}
                  <SocialLinks product={data} />
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <CustomerReviews productId={data.product_id || param.productId} />
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}
